import { render, staticRenderFns } from "./ModalCancel.vue?vue&type=template&id=2096da46&scoped=true&"
import script from "./ModalCancel.vue?vue&type=script&lang=ts&"
export * from "./ModalCancel.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCancel.vue?vue&type=style&index=0&id=2096da46&lang=scss&scoped=true&"
import style1 from "./ModalCancel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2096da46",
  null
  
)

export default component.exports